import React from 'react';
import {CallbackComponent} from "redux-oidc";
import {loadUser} from 'redux-oidc';
import {withRouter} from 'react-router-dom';
import userManager from "../../userManager";
import {useDispatch, useSelector} from "react-redux";

const Login = props => {

  const dispatch = useDispatch();
  const formData = useSelector(state => state.form);
  const {form, redirectTo} = formData;
  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={() => {
        loadUser(props.store, userManager)
          .then(() => {
            if (redirectTo) {
             // dispatch(redirectTrigger(true, () => props.history.push(redirectTo)));
              props.history.push(redirectTo)
            } else if (form) {
              props.history.push(`/${form}`);
            } else {
              props.history.push('/');
            }
          })
      }}
      errorCallback={error => {
        console.error(error);
        props.history.push('/');
      }}
    >
      <div>Logging in...</div>
    </CallbackComponent>
  );

};

export default withRouter(props => <Login {...props}/>);
